var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.986 263.746L352 248V144C369.75 144 384 129.75 384 112V48C384 21.49 362.51 0 336 0H48C21.49 0 0 21.49 0 48V466.75C0 475.123 3.314 483.156 9.219 489.093L32 512H96L128 480L160 512H224L256 480L288 512H352L384 480L416 512H480L502.625 489.375C508.628 483.372 512 475.231 512 466.742V388C512 329.229 472.002 278 414.986 263.746ZM48 48H336V96H48V48ZM464 416H48V144H304V192H240C231.2 192 224 199.2 224 208V208C224 216.8 231.2 224 240 224H304V256H240C231.2 256 224 263.2 224 272V272C224 280.8 231.2 288 240 288H314.125L403.375 310.25C439.125 319.25 464 351.125 464 387.875V416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoot);
export default __webpack_public_path__ + "static/media/boot.c94ca7116c9e7adcf89b6b811435b17b.svg";
export { ForwardRef as ReactComponent };